import { NativeError, RuntimeError } from '@belimo-retrofit-portal/logic';
import { SagaIterator } from 'redux-saga';
import { call as callEffect } from 'redux-saga/effects';
import { copyAsset } from 'src/modules/asset/sagas/utils/copyAsset';
import { createProject } from 'src/modules/common/sagas/utils/createProject';
import { Project } from 'src/modules/common/types/Project';
import { getProjectCopyName } from 'src/modules/project-list/sagas/utils/getProjectCopyName';
import { all, call } from 'typed-redux-saga';

export function* copyProject(project: Project): SagaIterator<Project> {
  try {
    const title = yield* call(getProjectCopyName, project);
    const cover = project.data.cover
      ? yield* call(copyAsset, project.data.cover)
      : null;
    const files = yield* all(
      project.data.report.appendix.files
        .map((attachment) => callEffect(copyAsset, attachment)),
    );

    return yield* call(createProject, {
      ...project.data,
      title: title,
      cover: cover,
      report: {
        ...project.data.report,
        appendix: {
          ...project.data.report.appendix,
          files,
        },
      },
    });
  } catch (error) {
    throw new RuntimeError('Could not copy project', { project }, NativeError.wrap(error));
  }
}
